import {SET_SEARCH_QUERY} from "../actions";

export default function searchQueryReducer(state = "", action) {
    switch (action.type) {
        case SET_SEARCH_QUERY:
            return {...state, query: action.payload};
        default:
            return state;
    }
}